<template>
  <v-row align="center" justify="center" no-gutters v-if="loading === true">
    <v-progress-circular indeterminate></v-progress-circular>
  </v-row>
  <v-row align="stretch" v-else-if="getFilteredData.length > 0">
    <v-col
      cols="12"
      sm="4"
      lg="3"
      v-for="item in getFilteredData"
      :key="item.id"
    >
      <v-sheet
        width="100%"
        height="100%"
        rounded
        color="#81C784"
        class="no-print"
      >
        <div class="pa-2">
          <v-row dense no-gutters>
            <span class="overline font-weight-medium">{{
              getName(item)
            }}</span></v-row
          >
          <v-row class="mt-2" align="end" justify="start" dense no-gutters>
            <span
              v-if="item.quantity !== null"
              class="overline font-weight-medium"
              style="font-size: 1rem !important;"
              >{{ item.quantity | round2 }}</span
            >
            <span v-if="item.quantity !== null" class="overline ml-1">{{
              item.unit
            }}</span>
            <span v-else class="overline">Quantité à confimer</span>
          </v-row>
          <v-row
            v-if="item.comments !== null"
            class="mt-2"
            align="center"
            justify="start"
            dense
            no-gutters
          >
            <span class="overline" style="font-size: 0.55rem !important;">
              {{ item.comments }}
            </span>
          </v-row>
          <v-row
            align="center"
            justify="space-between"
            no-gutters
            dense
            class="mt-2"
          >
            <v-btn x-small color="#A5D6A7" @click="delay(item)">
              Reporter
            </v-btn>
            <Prompt
              activator-icon="fa-check"
              activator-text="Confirmer"
              activator-icon-size="x-small"
              activator-size="x-small"
              color="#43A047"
              type="number"
              input-text="Quantité produite"
              submitText="Confimer la préparation"
              :initial-value="item.quantity"
              @submit="v => comfirm(item, v)"
            ></Prompt>
          </v-row>
        </div>
      </v-sheet>

      <!-- <v-row
        dense
        align="center"
        justify="space-between"
        no-gutters
        class="only-print"
      >
        <span class="overline font-weight-medium">{{ getName(item) }}</span>
        <div>
          <span
            v-if="item.quantity !== null"
            class="overline font-weight-medium"
            style="font-size: 1rem !important;"
            >{{ item.quantity | round2 }}</span
          >
          <span v-if="item.quantity !== null" class="overline ml-1">{{
            item.unit
          }}</span>
          <span v-else class="overline">Quantité à confimer</span>
        </div>
      </v-row>

      <p class="only-print mt-1 overline" style="font-size: 0.6rem !important;">
        {{ item.comments }}
      </p> -->
    </v-col>
  </v-row>
  <v-row align="center" no-gutters v-else>
    <span class="caption">Aucune préparation planifiée</span>
  </v-row>
</template>

<script>
import { api } from "@/api";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "PreparationSlipViewerScheduledPrepGrid",
  props: {
    date: {
      required: true
    }
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapGetters(["getScheduledPreparations", "getRecipes", "getStoreId"]),
    getFilteredData() {
      return this.getScheduledPreparations.filter(
        x =>
          x.is_done === false && moment(x.date).isSame(moment(this.date), "day")
      );
    }
  },
  data() {
    return {
      loading: false,
      headers: [{ value: "name" }, { value: "quantity" }]
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        await this.$store.dispatch("loadScheduledPreparations");
      } finally {
        this.loading = false;
      }
    },
    getName(item) {
      const r = this.getRecipes.find(x => x.id === item.fk_recipe);
      if (r) {
        return r.nom;
      }
      return "";
    },
    async comfirm(item, value) {
      if (value !== null) {
        const tasks = [];
        const prepData = {
          ...item,
          is_done: true
        };
        tasks.push(
          this.$store.dispatch("updateScheduledPreparation", prepData)
        );
        const r = this.getRecipes.find(x => x.id === item.fk_recipe);
        if (r) {
          const trasactionData = {
            id: r.fk_produit_intermediaire,
            quantity: value
          };
          tasks.push(api.postProduction(trasactionData));
        }
        await Promise.all(tasks);
        this.$store.dispatch("loadInventoryRecords", {
          store: this.getStoreId,
          latest: true
        });
      }
    },
    async delay(item) {
      const d = {
        ...item,
        date: moment(item.date)
          .add(1, "day")
          .format("YYYY-MM-DD")
      };
      this.$store.dispatch("updateScheduledPreparation", d);
    }
  }
};
</script>

<style></style>
